import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import LazyLoad from 'react-lazyload';
import { Box, Image, Paragraph, Heading, HashtagList } from 'components';
import './BoxImageContent.scss';

class BoxImageContent extends Component {
  render() {
    const { additionalClass, item } = this.props;
    const {
      image,
      caption,
      headline,
      description,
      tags,
      link,
      backgroundColor,
      id,
    } = item;

    return (
      <Box
        link={link}
        id={id}
        backgroundColor={backgroundColor}
        additionalClass={`box-image-content ${additionalClass}`}
        clickable
      >
        <LazyLoad once offset={200} height={150}>
          <Image src={image} additionalClass={'box-image-content__image'} />
        </LazyLoad>
        <div className={'box-image-content__main'}>
          <div>
            {caption && (
              <Paragraph
                size={'small'}
                additionalClass={'text--bold box-image-content__caption'}
              >
                {ReactHtmlParser(caption)}
              </Paragraph>
            )}
            <Heading
              size={'medium'}
              type={3}
              additionalClass={'text--bold box-image-content__content'}
            >
              {ReactHtmlParser(headline)}
            </Heading>
            {description && (
              <Paragraph
                additionalClass={'box-image-content__description text--light'}
                spaced
              >
                {ReactHtmlParser(description)}
              </Paragraph>
            )}
          </div>
          {tags && (
            <div className={'box-image-content__tags'}>
              <HashtagList color={'gray-medium'} data={tags} />
            </div>
          )}
        </div>
      </Box>
    );
  }
}

BoxImageContent.defaultProps = {
  additionalClass: '',
};

BoxImageContent.propTypes = {
  item: PropTypes.shape().isRequired,
  additionalClass: PropTypes.string,
};

export default BoxImageContent;
